<template>
  <span>
    <q-btn stack flat dense
      class="q-ml-sm"
      icon="las la-angle-left"
      :disable="!latLng"
      @click="previous"
    >
      <!-- :label="isLabel ? $t('names.previous') : null" -->
      <q-tooltip>{{ $t('names.previous') }}</q-tooltip>
    </q-btn>
    <q-btn stack flat dense
      class="q-ml-sm"
      icon="las la-angle-right"
      :disable="!latLng"
      @click="next"
    >
      <!-- :label="isLabel ? $t('names.next') : null" -->
      <q-tooltip>{{ $t('names.next') }}</q-tooltip>
    </q-btn>
    <q-btn stack flat dense
      class="q-ml-sm"
      icon="las la-undo"
      :disable="!latLng"
      @click="rotate(90)"
    >
      <!-- :label="isLabel ? '90' : null" -->
      <q-tooltip>
        {{ $t('tools.panorama.rotateLeft') }}
      </q-tooltip>
    </q-btn>
    <q-btn stack flat dense
      class="q-ml-sm"
      icon="las la-sync"
      :disable="!latLng"
      @click="rotate(180)"
    >
      <!-- :label="isLabel ? '180' : null" -->
      <q-tooltip>
        {{ $t('tools.panorama.rotate180') }}
      </q-tooltip>
    </q-btn>
    <q-btn stack flat dense
      class="q-ml-sm"
      icon="las la-redo"
      :disable="!latLng"
      @click="rotate(-90)"
    >
      <!-- :label="isLabel ? '90' : null" -->
      <q-tooltip>
        {{ $t('tools.panorama.rotateRight') }}
      </q-tooltip>
    </q-btn>
    <panorama-show-lateral-button />
  </span>
</template>

<script>
import { ClosePopup, QBtn, QTooltip } from 'quasar'
import { mapState } from 'vuex'
import PanoramaShowLateralButton from './PanoramaShowLateralButton.vue'

export default {
  props: ['isHeader'],
  data () {
    return {
      showCampaignDialog: false,
      showDropdownCampaigns: false,
      showDropdownOptions: false
    }
  },
  components: {
    QBtn, QTooltip, PanoramaShowLateralButton
  },
  directives: {
    ClosePopup
  },
  computed: {
    ...mapState({
      head: state => state.panorama.head,
      latLng: state => state.panorama.latLng,
      laterals: state => state.panorama.laterals,
      showPannellum: state => state.panorama.showPannellum,
      showPotree: state => state.panorama.showPotree
    }),
    isLabel () {
      return this.isHeader && this.$q.screen.gt.md
    }
  },
  methods: {
    activateLateral () {
      const isActive = this.$store.state.panorama.showLateral
      if (!isActive) {
        this.$store.dispatch('panorama/selectLateral')
      } else {
        this.$store.commit('panorama/setSelectedLateral', null)
      }
      this.$store.commit('panorama/setShowLateral', !isActive)
    },
    previous () {
      this.$store.dispatch('panorama/getPreviousPano')
    },
    next () {
      this.$store.dispatch('panorama/getNextPano')
    },
    rotate (angle) {
      const head = this.head + angle
      this.$store.commit('panorama/setHead', { head, from: 'tools' })
      const isActive = this.$store.state.panorama.showLateral
      if (isActive) {
        this.$store.dispatch('panorama/selectLateral')
      }
    }
  }
}
</script>
